import customErrorsGenerator from './fullSecurityErrorsTypes/index';

const cameraButton = 1;
const acceptButton = 2;
const reloadButton = 3;

const {errorNewStyle, errorTypes} = customErrorsGenerator({buttons: {cameraButton,acceptButton,reloadButton}});

export default {
    errors: {
        codeNotControlled: {
            button: reloadButton,
            principalMessage: '',
            secondaryMessage: 'La página se actualizará para que puedas continuar con tu proceso. Si el error persiste consulta con tu proveedor.',
            codeNotControlledMessage: 'Error código no controlado',
            reportToBack: true,
            customClass: 'new-type-error'
        },
        default: {
            button: reloadButton,
            principalMessage: '',
            secondaryMessage: 'La página se actualizará para que puedas continuar con tu proceso. Si el error persiste consulta con tu proveedor.',
            errorTips: []
        },
        defaultImage: {
            button: acceptButton,
            principalMessage: '',
            secondaryMessage: 'No se ha podido cargar la imagen. Por favor intenta realizar el proceso nuevamente nuevamente. Si el error persiste consulta con tu proveedor.',
            errorTips: []
        },
        login: {
            button: acceptButton,
            principalMessage: 'No se puede iniciar el proceso de firma',
            secondaryMessage: 'Te recomendamos revisar los siguientes puntos',
            errorTips: [
                'Asegúrate de que estés con buena conexión a internet',
                'Cierra todas las pestañas abiertas en tu celular que puedan entorpecer el proceso',
                'Actualiza la página para intentarlo nuevamente',
            ]
        },
        authentication: {
            button: acceptButton,
            principalMessage: 'Acceso denegado',
            secondaryMessage: 'Contraseña incorrecta',
            errorTips: [
                'Revise la clave recibida para el día de hoy',
                'Asegúrese de poner los dígitos correctamente'
            ]
        },
        IdentityCardFrontCapture: {
            button: cameraButton,
            principalMessage: 'No pudimos leer la información frontal de la cédula correctamente',
            secondaryMessage: 'Te recomendamos intentar nuevamente siguiendo estos consejos',
            errorTips: [
                'Asegúrate que la cédula esté correctamente posicionado',
                'Asegúrate que la cédula corresponda al rut del proceso',
                'Intenta mejorar la iluminación de la toma',
                'Verifica que no haya un reflejo de luz sobre la cédula',
                'Mantén la cámara fija y recta para evitar una foto borrosa'
            ]
        },

        finalAnalysis: {
            button: acceptButton,
            principalMessage: 'Ha ocurrido un error al finalizar el proceso',
            secondaryMessage: 'Ha ocurrido un error inesperado al intentar finalizar el proceso. Por favor inténtalo nuevamente. Si el error persiste consulta con tu proveedor',
            errorTips: []
        },
        IdentityCardBackCapture: {
            button: cameraButton,
            principalMessage: 'No pudimos leer la información trasera de la cédula correctamente',
            secondaryMessage: 'Te recomendamos intentar nuevamente siguiendo estos consejos',
            errorTips: [
                'Asegurarse que el carnet esté alineado con la imagen',
                'Asegúrate que la cédula corresponda al rut del proceso',
                'Intenta mejorar la iluminación de la toma',
                'Verifica que no haya un reflejo de luz sobre la cédula',
                'Mantén la cámara fija para evitar una foto borrosa'
            ]
        },
        faceCapture: {
            button: cameraButton,
            principalMessage: 'No pudimos reconocer su rostro correctamente',
            secondaryMessage: 'Te recomendamos intentar nuevamente siguiendo estos consejos',
            errorTips: [
                'Asegurarse que el dispositivo no esté volteado',
                'Intenta mejorar la iluminación de la toma',
                'Asegurarse que sólo aparece su rostro',
                'Mantén la cámara fija para evitar una foto borrosa',
                'Asegurarse de tener el rostro descubierto'
            ]
        },
        loadDocumentPDF: {
            button: acceptButton,
            principalMessage: 'Ha ocurrido un error con el documento',
            secondaryMessage: 'Por favor actualice el sitio y vuelva a intentarlo. Si el error persiste comuníquese con su proveedor.',
            errorTips: []
        },
        loadSourcePDF: {
            button: acceptButton,
            principalMessage: 'Ha ocurrido un error con el vínculo del documento',
            secondaryMessage: 'Por favor actualice el sitio y vuelva a intentarlo. Si el error persiste comuníquese con su proveedor.',
            errorTips: []
        },
        loadPageRenderPDF: {
            button: acceptButton,
            principalMessage: 'Ha ocurrido un error con la visualización del documento',
            secondaryMessage: 'Una o más páginas del documento no se han podido mostrar. Por favor actualice el sitio y vuelva a intentarlo. Si el error persiste comuníquese con su proveedor.',
            errorTips: []
        },
        loadPagePDF: {
            button: acceptButton,
            principalMessage: 'Ha ocurrido un error con la visualización del documento',
            secondaryMessage: 'Una o más páginas del documento no han podido ser cargadas. Por favor actualice el sitio y vuelva a intentarlo. Si el error persiste comuníquese con su proveedor.',
            errorTips: []
        },
        notAccessDesktop: {
            button: acceptButton,
            principalMessage: 'Debe acceder desde un dispositivo móvil',
            secondaryMessage: 'Hemos detectado que se encuentra iniciando el proceso de firma desde un computador. Te pedimos por favor utilizar un tablet o teléfono móvil para poder continuar.',
            errorTips: []
        },
        ...errorNewStyle
    },
    isNewStyleError: errorType => errorTypes.includes(errorType)
};
